import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid } from "@material-ui/core";
import MuiRadioGroup from "Components/MuiRadioGroup/MuiRadioGroup";
import { useSetState } from "Helpers/Hooks";
import { CONSTRUCTION_RESULT } from "Stores/actionTypes";

const QualityControl = () => {
  const { constructionResult } = useSelector((state) => ({
    constructionResult: state.construction.constructionResult,
  }));
  const dispatch = useDispatch();
  const [controls, setControls] = useSetState({
    action: {
      type: "radio",
      value: { value: 19, key: "unit_images" },
      items: [
        { value: 19, key: "unit_images" },
        { value: 17, key: "QC_prj_Label" },
        { value: 18, key: "QC_glass_Label" },
        { value: 31, key: "QC_ProductionCardWithDetails" },
        { value: 32, key: "QC_LargerUnitImages" },
      ],
    },
  });

  const onChangeRadio = (name, key, value) => {
    setControls({ [name]: { value: value } });
    dispatch({
      type: CONSTRUCTION_RESULT,
      constructionResult: {
        ...constructionResult,
        Extra_QualityControl: value,
        action: value.value
      },
    });
  };

  const onClear = () => {
    setControls({ action: {
      value: constructionResult.Extra_QualityControl,
    }});
    dispatch({
      type: CONSTRUCTION_RESULT,
      constructionResult: {
        ...constructionResult,
        action: constructionResult.Extra_QualityControl.value,
        pageIndex: 230,
      },
    });
  };

  useEffect(() => {
    onClear();
  }, []);

  return (
    <>
      <Grid container className="p-3">
        <Grid item xs={12}>
          <MuiRadioGroup
            name="action"
            value={controls.action.value}
            items={controls.action.items}
            onChange={onChangeRadio}
            translate={true}
            className="horizontalRadio "
          />
        </Grid>
      </Grid>
    </>
  );
};

export default QualityControl;
